import { fplsFetch, getVersionRecords, getAvailableFields } from '../../../r/utils';

const fetchReportSuccess = (payload) => ({
  type: 'FETCH_REPORT_SUCCESS',
  payload
})

const fetchReportFailure = (payload) => ({
  type: 'FETCH_REPORT_FAILURE',
  payload
})

function doFetchReport (reportID, formId) {
  return dispatch => {
    fplsFetch({
      method: 'GET',
      url: `/api/v2/public/${formId}/report/${reportID}`
    }).then(json => {
      if (json.error) {
        console.error('Fetch Report Error:', json.error)
        dispatch(fetchReportFailure({ error: json.error }))
      } else {
        if (json.hasOwnProperty('task_status_id')) {
          setTimeout(() => {
            waitForTaskToComplete(dispatch, json.task_status_id, reportID)
          }, 3000)
        }
        else {
          const versionsRecords = json.versions_records
          const report = json.report
          const majorVersion = report.version
          let fields = JSON.parse(JSON.stringify(json.fields))
          const [records, recordsObj] = getVersionRecords(versionsRecords, majorVersion)
          if (majorVersion === -1) {
            fields = getAvailableFields(recordsObj, fields)
          }

          dispatch(fetchReportSuccess({
            reportID: Number(reportID),
            report,
            records,
            fields,
            loading: false,
            submissionsCount: json.submissions_count,
            responses: json.responses
          }))
        }
      }
    })
  }
}

/**
 * 
 * @param {Dispatch<any>} dispatch
 * @param {String} taskStatusId 
 * @param {String | Number} reportID 
 * @param {String | Number} formId 
 */
function waitForTaskToComplete (dispatch, taskStatusId, reportID, formId) {
  fplsFetch({
    method: 'GET',
    url: `/api/v2/user/form_record_status/${taskStatusId}`
  })
  .then(
    function (response) {
      if (response.error) {
        let msg = `Error while loading form report. Details: ${response.error}`
        dispatch(fetchReportFailure({ error: response.error }))
        console.error('Task Wait Error', msg)
      }
      if (response.status === 'success') {
        clearTimeout(waitForTaskToComplete)
        dispatch(doFetchReport(reportID, formId))
      } else if (response.status === 'pending') {
        setTimeout(() => {
          waitForTaskToComplete(dispatch, taskStatusId, reportID, formId)
        }, 3000)
      } else {
        // When metric  status is not found in the model
        clearTimeout(waitForTaskToComplete)
        dispatch(doFetchReport(reportID, formId))
      }
    }
  )
}

export default {
  doFetchReport
}
